import * as types from '../../mutation-types.js';
import http from '@service/http';
import util from '@common/utils/util';

/**
 * 个人中心STORE
 */
export default {
  state: {

  },
  actions: {
    /*8.1.获取会员订单数*/
    getMemOrderCount({ commit }) {
      return http.post({
        fn: 'mallsale.memOrderHandler.getMemOrderCount',
        param: []
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    /*8.2.分页查询会员订单*/
    pageMemOrder({ commit }, data) {
      return http.post({
        fn: 'mallsale.memOrderHandler.pageMemOrder',
        param: data
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    /*  8.3.获取会员订单详情*/
    getMemOrderDetail({ commit }, data) {
      return http.post({
        fn: 'mallsale.memOrderHandler.getMemOrderDetail',
        param: [data]
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    /*8.4.取消订单*/
    cancelMemOrder({ commit }, data) {
      return http.post({
        fn: 'mallsale.memOrderHandler.cancelMemOrder',
        param: [data]
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    /*8.5.申请退单*/
    applyBackOrder({ commit }, data) {
      return http.post({
        fn: 'mallsale.memOrderHandler.applyBackOrder',
        param: data
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    /*8.6.分页查询会员发票信息*/
    pageMemOrderInvoice({ commit }, data) {
      return http.post({
        fn: 'mallsale.invoiceHandler.pageMemOrderInvoice',
        param: data
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    /*5.9.新增收货地址*/
    addAddress({ commit }, memAddr) {
      return http.post({
        fn: 'mallmem.addressHandler.addAddress',
        param: [memAddr]
      }).then(result => {
        if (result && result.success) {
          return Promise.resolve(result.target);
        } else {
          return Promise.reject((result && result.message) || "新增失败！");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*5.10.修改收货地址*/
    editAddress({ commit }, memAddr) {
      return http.post({
        fn: 'mallmem.addressHandler.editAddress',
        param: memAddr
      }).then(result => {
        if (result && result.success) {
          return Promise.resolve(result.target);
        } else {
          return Promise.reject((result && result.message) || "修改失败！");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*5.11.设置默认收货地址*/
    doSetDefaultAddress({ commit }, addressIdMsg) {
      return http.post({
        fn: 'mallmem.addressHandler.doSetDefaultAddress',
        param: addressIdMsg
      }).then(result => {
        if (result && result.success) {
          return Promise.resolve(result.target);
        } else {
          return Promise.reject((result && result.message) || "设置为默认地址失败！");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*5.12.获取收货地址详情 */
    getAddress({ commit }, addressId) {
      return http.post({
        fn: 'mallmem.addressHandler.getAddress',
        param: [addressId]
      }).then(result => {
        if (result && result.success) {
          return Promise.resolve(result.target);
        } else {
          return Promise.reject((result && result.message) || "获取信息失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*5.13.删除收货地址*/
    removeAddress({ commit }, addressId) {
      return http.post({
        fn: ' mallmem.addressHandler.removeAddress',
        param: [addressId]
      }).then(result => {
        if (result && result.success) {
          return Promise.resolve(result.target);
        } else {
          return Promise.reject((result && result.message) || "删除失败！");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*5.14.列出收货地址*/
    listAddress({ commit }, ) {
      return http.post({
        fn: 'mallmem.addressHandler.listAddress',
        param: []
      }).then(result => {
        if (result && result.success) {
          return Promise.resolve(result.target);
        } else {
          return Promise.reject((result && result.message) || "获取信息失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*7.7.获取指定区域ID的所有下级区域*/
    listAreaMsg({ commit }, upAreaId) {
      return http.post({
        fn: 'mallmem.addressHandler.listAreaMsg',
        param: [upAreaId]
      }).then(result => {
        if (result && result.success && result.target || result.target.success) {
          return Promise.resolve(result);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*10.1.获取订单还未评价的商品*/
    getNotCommentGoods({ commit }, stOrderId) {
      return http.post({
        fn: 'mallsale.commentHandler.getNotCommentGoods',
        param: [stOrderId]
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*10.2.增加商品评价mallsale.commentHandler.addGoodsComment*/
    addGoodsComment({ commit }, CommentData) {
      console.log("CommentData", CommentData);
      //debugger;
      return http.post({
        fn: 'mallsale.commentHandler.addGoodsComment',
        param: CommentData
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*  10.3.修改商品评价*/
    modGoodsComment({ commit }, CommentData) {
      return http.post({
        fn: 'mallsale.commentHandler.modGoodsComment',
        param: CommentData
      }).then(result => {
        if (result && result.success) {
          return Promise.resolve(result.target);
        } else {
          return Promise.reject((result && result.message) || "修改失败！");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*10.4.删除商品评价mallsale.commentHandler.delGoodsComment*/
    delGoodsComment({ commit }, commId) {
      return http.post({
        fn: 'mallsale.commentHandler.delGoodsComment',
        param: [commId]
      }).then(result => {
        if (result && result.success) {
          return Promise.resolve(result.target);
        } else {
          return Promise.reject((result && result.message) || "删除失败！");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*10.5.分页查询商品评价mallsale.commentHandler.pageGoodsComment*/
    pageGoodsComment({ commit }, data) {
      return http.post({
        fn: 'mallsale.commentHandler.pageGoodsComment',
        param: data
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*10.6.获取商品评价详情*/
    getGoodsComment({ commit }, commId) {
      return http.post({
        fn: 'mallsale.commentHandler.getGoodsComment',
        param: [commId]
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*6.1.设置出生日期*/
    doSetBirthDay({ commit }, birthday) {
      return http.post({
        fn: 'mallmem.memInfoHandler.doSetBirthDay',
        param: [birthday]
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*6.2.设置会员头像*/
    doSetMemImage({ commit }, memImageId) {
      return http.post({
        fn: 'mallmem.memInfoHandler.doSetMemImage',
        param: [memImageId]
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*6.3.设置昵称*/
    doSetNickName({ commit }, memImageId) {
      return http.post({
        fn: 'mallmem.memInfoHandler.doSetNickName',
        param: [memImageId]
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*6.4.设置性别*/
    doSetSex({ commit }, sex) {
      return http.post({
        fn: 'mallmem.memInfoHandler.doSetSex',
        param: [sex]
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*6.5.获取会员账户信息*/
    getMemAccountMsg({ commit }, ) {
      return http.post({
        fn: 'mallmem.accountHandler.getMemAccountMsg',
        param: []
      }).then(result => {
        if (result && result.success && result.target || result.target.success) {
          return Promise.resolve(result.target);
        } else {
          return Promise.reject((result && (result.message)) || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*10.1.分页查询会员商品收藏*/
    pageGoodsFav({ commit }, data) {
      return http.post({
        fn: 'mallsale.goodsFavHandler.pageGoodsFav',
        param: data
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*7.1.批量删除会员商品收藏*/
    delGoodsFavBatch({ commit }, data) {
      return http.post({
        fn: 'mallsale.goodsFavHandler.delGoodsFavBatch',
        param: [data]
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*10.2.删除会员商品收藏  */
    delGoodsFav({ commit }, favId) {
      return http.post({
        fn: 'mallsale.goodsFavHandler.delGoodsFav',
        param: [favId]
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*6.3.获取会员详细信息*/
    getMemDetailInfo({ commit }) {
      return http.post({
        fn: 'mallmem.memInfoHandler.getMemDetailInfo',
        param: []
      }).then(result => {
        if (result && result.success && result.target || result.target.success) {
          return Promise.resolve(result.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*12.3.分页查询会员红包mallsale.couponHandler.pageMemRedpacket*/
    pageMemRedpacket({ commit }, data) {
      return http.post({
        fn: 'mallsale.couponHandler.pageMemRedpacket',
        param: data
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*分页查询我的优惠券mallsale.couponHandler.pageMemCoupon*/
    pageMemCoupon({ commit }, data) {
      return http.post({
        fn: 'mallsale.couponHandler.pageMemCoupon',
        param: data
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*删除我的[优惠或者是红包]mallsale.couponHandler.delMemCoupon*/
    delMemCoupon({ commit }, data) {
      return http.post({
        fn: 'mallsale.couponHandler.delMemCoupon',
        param: [data]
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*15.4.再次购买*/
    getOrderSettleMsgForOrder({ commit }, data) {
      return http.post({
        fn: ' mallsale.settleHandler.getOrderSettleMsgForOrder',
        param: [data]
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*22.6.获取分享订单商品列表*/
    listOrderGoodsMsgByOrderId({ commit }, data) {
      return http.post({
        fn: ' mallsale.shareHandler.listOrderGoodsMsgByOrderId',
        param: [data]
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    /*22.7.提交晒家分享数据*/
    submitShareData({ commit }, data) {
      return http.post({
        fn: ' mallsale.shareHandler.submitShareData',
        param: data
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },

    /*线下订单查询*/
    queryOrder({ commit }, projectCode) {
      return http.post({
        fn: 'mallsale.memOrderHandler.queryOrder',
        param: [projectCode]
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },

  },
  mutations: {

  },
  getters: {

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/personal/index.js